import React from 'react';
import { StyleSheet } from 'react-native';

import { ds } from '@/components/lib/design.system';

import { Button } from '../ButtonComponent';
import { Text } from '../TextComponent';
import { Box } from '../lib/components';

type EntryActionButtonProps = {
    icon: React.ReactElement;
    label: string;
    testID?: string;
    onPress: () => void;
};

export const EntryActionButton = ({ icon, label, testID, onPress }: EntryActionButtonProps) => (
    <Box flex={1} alignItems="center" gap="s6">
        <Button label={icon} onPress={onPress} testID={testID} style={styles.iconButton} analyticsTag={label} />
        <Text variant="labelLarge" color={ds.colorToken.text.primary} textAlign="center" letterSpacing={-0.08}>
            {label}
        </Text>
    </Box>
);

const styles = StyleSheet.create({
    iconButton: {
        width: '100%',
        height: 56,
        borderRadius: 16,
        backgroundColor: ds.colorValue.background.transparent.subtle,
        borderWidth: 1,
        borderColor: ds.colorValue.border.strong,
    },
});
